import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ngxCapitalize', standalone: true })
export class NgxCapitalizePipe implements PipeTransform {
  transform(input: string): string {
    return input?.length ? input.charAt(0).toUpperCase() + input.slice(1).toLowerCase() : input;
  }
}
